import { OverlayTrigger, Tooltip } from "react-bootstrap"
import { useNavigate } from "react-router-dom"

import Loading from "@/components/Loading/Loading"

import styles from "./Button.module.css"

export type ButtonVariants2 =
  | "primary"
  | "secondary"
  | "secondary_border"
  | "dark"
  | "red"
  | "lightRed"
  | "lightBlue"
  | "normal"
  | "clear"

interface ButtonProps {
  variant?: ButtonVariants2
  children: React.ReactNode
  to?: string
  className?: string
  onClick?: () => void
  type?: "button" | "submit" | "reset"
  isLoading?: boolean
  small?: boolean
  big?: boolean
  fixedWidth?: boolean
  target?: string
  title?: string
  disabled?: boolean
  icon?: React.ReactNode
  style?: React.CSSProperties
}

export default function Button({
  variant = "secondary",
  children,
  to,
  className,
  onClick,
  type,
  isLoading,
  small,
  big,
  fixedWidth,
  target,
  title,
  disabled,
  icon,
  style,
}: ButtonProps) {
  const navigate = useNavigate()

  const content = (
    <button
      style={style}
      className={`${styles.button} ${styles[`button__${variant}`]} ${className || ""} ${big ? styles.button__big : ""} ${small ? styles.button__small : ""} ${fixedWidth ? styles.button__fixed : ""}`}
      type={type || "button"}
      onClick={() => {
        onClick?.()
        if (to) {
          if (target == "_blank") window.open(to)
          else navigate(to)
        }
      }}
      disabled={disabled || isLoading}
    >
      {isLoading ? (
        <Loading
          className={`loading--small ${variant == "secondary" ? "" : "light"}`}
          widthFit
        />
      ) : (
        icon && <div>{icon}</div>
      )}
      {isLoading || !small ? children : ""} {/* {children} */}
    </button>
  )

  return (
    <>
      {title ? (
        <OverlayTrigger
          placement={"top"}
          overlay={
            <Tooltip id="tooltip" style={{ position: "fixed" }}>
              {title}
            </Tooltip>
          }
        >
          {content}
        </OverlayTrigger>
      ) : (
        content
      )}
    </>
  )
}
